export { default as CursosProfesorGrid } from './Listar';
export { default as DetalleCurso } from './Detalle';
// export { default as ArchivoAgregar } from './ArchivoAgregar';
export { default as FormularioAgregar } from './FormularioAgregar';
export { default as RecuperarClase } from './RecuperarClase';
export { default as RecuperacionesProfe } from './Recuperaciones';
export { default as ReporteCreditosAlumno } from './CreditosAlumno';
export { default as PuntuacionesClases } from './PuntuacionesClases';
